(() => {
  const root = document.querySelector('[data-pw-root]');
  if (!root || root.dataset.pwInitialized === 'true') return;
  root.dataset.pwInitialized = 'true';

  const orderPanel = root.querySelector('[data-pw-order]');
  const orderItems = root.querySelector('[data-pw-order-items]');
  const totalNode = root.querySelector('[data-pw-total]');
  const statusNode = root.querySelector('[data-pw-status]');
  const openButtons = root.querySelectorAll('[data-pw-open-order]');
  const launcher = root.querySelector('[data-pw-open-order].pw-order-launcher');
  const countNode = root.querySelector('[data-pw-count]');
  const checkoutButton = root.querySelector('[data-pw-checkout]');
  const cart = new Map();

  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(cents / 100); }
    catch (_) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); }
  };
  const safeQty = (value) => Math.max(1, Math.min(20, parseInt(value, 10) || 1));

  // Reveal sections and animate a 3D block as each section enters the viewport.
  const revealItems = root.querySelectorAll('[data-pw-reveal]');
  // El catálogo debe estar visible desde la primera carga, también en móviles.
  root.querySelector('#pw-catalog')?.classList.add('is-visible');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else revealItems.forEach((item) => item.classList.add('is-visible'));

  // Quantity controls.
  root.querySelectorAll('[data-pw-quantity]').forEach((control) => {
    const input = control.querySelector('[data-pw-qty]');
    control.querySelector('[data-pw-minus]')?.addEventListener('click', () => { input.value = Math.max(1, safeQty(input.value) - 1); });
    control.querySelector('[data-pw-plus]')?.addEventListener('click', () => { input.value = Math.min(20, safeQty(input.value) + 1); });
    input?.addEventListener('change', () => { input.value = safeQty(input.value); });
  });

  // Pieces-only filters; old 320 metadata is temporarily normalized to the corrected 312 count.
  const pieceButtons = Array.from(root.querySelectorAll('[data-pw-piece-choice]'));
  const resultsCount = root.querySelector('[data-pw-results-count]');
  const noResults = root.querySelector('[data-pw-no-results]');
  const cards = Array.from(root.querySelectorAll('[data-pw-card]'));
  let activePieces = 'all';
  function normalized(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase(); }
  function piecesOf(card) {
    const raw = String(card.dataset.pieces || '');
    const match = raw.match(/\d+/);
    if (match) return match[0] === '320' ? '312' : match[0];
    const title = normalized(card.querySelector('h3')?.textContent + ' ' + card.textContent);
    const found = title.match(/\b(60|100|200|312|320)\b/);
    return found ? (found[1] === '320' ? '312' : found[1]) : '';
  }
  function applyFilters() {
    let visible = 0;
    cards.forEach(card => {
      const show = activePieces === 'all' || piecesOf(card) === activePieces;
      card.hidden = !show;
      if (show) visible++;
    });
    if (resultsCount) resultsCount.textContent = `Mostrando ${visible} ${visible === 1 ? 'referencia' : 'referencias'}`;
    if (noResults) noResults.hidden = visible !== 0;
  }
  function syncFilterButtons() {
    pieceButtons.forEach(button => {
      const active = (button.dataset.pwPieceChoice || 'all') === activePieces;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }
  function setPieces(value) {
    activePieces = value || 'all';
    syncFilterButtons(); applyFilters();
    if (value !== 'all') root.querySelector('#pw-catalog')?.scrollIntoView({behavior:'smooth', block:'start'});
  }
  function resetFilters() { activePieces = 'all'; syncFilterButtons(); applyFilters(); }
  pieceButtons.forEach(button => button.addEventListener('click', () => setPieces(button.dataset.pwPieceChoice || 'all')));
  root.querySelectorAll('[data-pw-reset]').forEach(button => button.addEventListener('click', resetFilters));
  root.querySelectorAll('[data-pw-size-link]').forEach(link => link.addEventListener('click', (event) => {
    event.preventDefault();
    setPieces(link.dataset.pwSizeLink || 'all');
    root.querySelector('#pw-catalog')?.scrollIntoView({behavior:'smooth', block:'start'});
  }));
  syncFilterButtons(); applyFilters();

  // Random dice recommendation uses only products available under the active piece filter.
  const dicePanel = root.querySelector('[data-pw-dice-panel]');
  const diceButton = root.querySelector('[data-pw-roll-dice]');
  const diceResult = root.querySelector('[data-pw-dice-result]');
  const diceView = root.querySelector('[data-pw-dice-view]');
  let recommendedCard = null;
  diceButton?.addEventListener('click', () => {
    const candidates = cards.filter(card => card.querySelector('[data-pw-add]')); // Siempre sortea entre todos los productos, aunque haya un filtro activo.
    if (!candidates.length) {
      if (diceResult) diceResult.textContent = 'No encontramos sets disponibles con esta selección. Prueba otro tamaño.';
      if (diceView) diceView.hidden = true;
      return;
    }
    dicePanel?.classList.remove('is-rolling');
    void dicePanel?.offsetWidth;
    dicePanel?.classList.add('is-rolling');
    diceButton.disabled = true;
    if (diceResult) diceResult.textContent = 'El dado está buscando tu próxima aventura…';
    window.setTimeout(() => {
      recommendedCard = candidates[Math.floor(Math.random() * candidates.length)];
      const name = (recommendedCard.querySelector('h3')?.textContent || 'un mundo sorpresa').replace(/[\[\]\"']/g, '').trim();
      const pieces = piecesOf(recommendedCard);
      if (diceResult) diceResult.textContent = `¡Salió ${name}${pieces ? `, en el set de ${pieces} piezas` : ''}! Este mundo te ha elegido.`;
      if (diceView) diceView.hidden = false;
      diceButton.disabled = false;
      dicePanel?.classList.remove('is-rolling');
    }, 850);
  });
  diceView?.addEventListener('click', () => {
    if (!recommendedCard) return;
    resetFilters();
    recommendedCard.scrollIntoView({behavior:'smooth', block:'center'});
    recommendedCard.classList.remove('pw-card-highlight');
    void recommendedCard.offsetWidth;
    recommendedCard.classList.add('pw-card-highlight');
    const addButton = recommendedCard.querySelector('[data-pw-add]');
    addButton?.focus({preventScroll:true});
  });


  // Product image lightbox: the corner arrow now opens the image at full viewport size.
  const lightbox = root.querySelector('[data-pw-lightbox]');
  const lightboxImage = root.querySelector('[data-pw-lightbox-image]');
  root.querySelectorAll('[data-pw-image-expand]').forEach((button) => button.addEventListener('click', () => {
    const image = button.closest('[data-pw-card]')?.querySelector('.pw-product-card__image');
    if (!image || !lightbox || !lightboxImage) return;
    lightboxImage.src = image.currentSrc || image.src; lightboxImage.alt = image.alt || 'Imagen ampliada del producto';
    lightbox.hidden = false; document.body.classList.add('pw-lightbox-open');
  }));
  const closeLightbox = () => { if (lightbox) lightbox.hidden = true; document.body.classList.remove('pw-lightbox-open'); };
  root.querySelector('[data-pw-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeLightbox(); });

  function renderOrder() {
    orderItems.innerHTML = '';
    let total = 0, count = 0;
    cart.forEach((item, key) => {
      const lineTotal = item.price * item.quantity;
      total += lineTotal; count += item.quantity;
      const row = document.createElement('div'); row.className = 'pw-order-line';
      const image = document.createElement('img'); image.alt = ''; image.src = item.image || ''; if (!item.image) image.hidden = true;
      const info = document.createElement('div');
      const title = document.createElement('p'); title.className = 'pw-order-line__title'; title.textContent = item.title;
      const meta = document.createElement('p'); meta.className = 'pw-order-line__meta'; meta.textContent = `${item.pieces ? item.pieces + ' piezas · ' : ''}${item.quantity} × ${money(item.price)}`;
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'pw-order-line__remove'; remove.textContent = 'Quitar';
      remove.addEventListener('click', () => { cart.delete(key); renderOrder(); });
      info.append(title, meta, remove);
      const price = document.createElement('div'); price.className = 'pw-order-line__price'; price.textContent = money(lineTotal);
      row.append(image, info, price); orderItems.append(row);
    });
    totalNode.textContent = money(total);
    if (countNode) countNode.textContent = String(count);
    const hasItems = cart.size > 0;
    orderPanel.hidden = !hasItems;
    if (launcher) launcher.hidden = !hasItems || !orderPanel.hidden;
    statusNode.textContent = '';
  }
  function openOrder() {
    if (!cart.size) {
      root.querySelector('#pw-catalog')?.scrollIntoView({behavior:'smooth'});
      return;
    }
    orderPanel.hidden = false;
    if (launcher) launcher.hidden = true;
    orderPanel.scrollTop = 0;
  }

  root.querySelectorAll('[data-pw-add]').forEach((button) => button.addEventListener('click', () => {
    const card = button.closest('[data-pw-card]');
    const qty = safeQty(card?.querySelector('[data-pw-qty]')?.value || 1);
    const variantId = String(button.dataset.variantId || '');
    if (!variantId) return;
    const existing = cart.get(variantId);
    cart.set(variantId, {
      variantId, title: button.dataset.productTitle || 'Set magnético',
      pieces: button.dataset.productPieces || '', price: Number(button.dataset.productPrice || 0),
      image: button.dataset.productImage || '', quantity: Math.min(20, qty + (existing?.quantity || 0))
    });
    renderOrder(); orderPanel.hidden = false; if (launcher) launcher.hidden = true;
    orderPanel.scrollTop = 0;
  }));

  openButtons.forEach((button) => button.addEventListener('click', openOrder));
  root.querySelector('[data-pw-final-order]')?.addEventListener('click', openOrder);
  root.querySelector('[data-pw-close]')?.addEventListener('click', () => {
    orderPanel.hidden = true;
    if (launcher) launcher.hidden = cart.size === 0;
  });
  root.querySelector('[data-pw-continue]')?.addEventListener('click', () => {
    orderPanel.hidden = true;
    if (launcher) launcher.hidden = cart.size === 0;
    root.querySelector('#pw-catalog')?.scrollIntoView({behavior:'smooth'});
  });

  checkoutButton?.addEventListener('click', async () => {
    if (!cart.size) return;
    checkoutButton.disabled = true; checkoutButton.textContent = 'Preparando tu pedido…'; statusNode.textContent = '';
    const items = Array.from(cart.values()).map((item) => ({id:Number(item.variantId), quantity:item.quantity}));
    try {
      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})
      });
      if (!response.ok) {
        let message = 'No pudimos agregar tu selección. Revisa la disponibilidad e inténtalo de nuevo.';
        try { const data = await response.json(); if (data.description) message = data.description; } catch (_) {}
        throw new Error(message);
      }
      // Go to the actual Shopify cart, where automatic discounts and the checkout button can be verified.
      window.location.href = `${rootUrl}cart`;
    } catch (error) {
      statusNode.textContent = error.message || 'Ocurrió un error. Inténtalo de nuevo.';
      checkoutButton.disabled = false; checkoutButton.textContent = 'Ir al carrito y pagar';
    }
  });
})();
